module.exports = __webpack_public_path__ + "img/slide9.accdddb8.png";